import { Image } from "@/components/common/Image"
import { ITableHead, Table } from "@/components/Table"
import { getCurrencyLogoUrl, statusColors } from "@/utils"
import { IBANExTransaction, ShortTransaction } from "@usher/pe-client-front-end-lib"
import { useMemo } from "react"
import { FormattedMessage } from "react-intl"

type Props = {
  type: string
  orders: (ShortTransaction | IBANExTransaction)[]
  isInitialized: boolean
  loading?: boolean
}
const TABLE_HEADS: ITableHead[] = [
  {
    key: "id",
  },
  {
    key: "logo",
  },
  {
    key: "date",
  },
  {
    key: "address",
  },
  {
    key: "from",
  },
  {
    key: "to",
  },
  {
    key: "status",
  },
]
export const ExchangeList = ({ type, orders, isInitialized }: Props) => {
  const isNotFound = isInitialized && orders.length === 0
  const tableData = useMemo(() => {
    return orders.map((order) => ({
      id: <div className="text-[#777e8a]">{"# " + order.id}</div>,
      logo: (
        <div>
          <Image className="w-5 h-5 mr-2" src={`coins/${getCurrencyLogoUrl(order.crypto_currency)}.svg`} alt={order.crypto_currency} />
          {order.crypto_currency_title}
        </div>
      ),
      data: <span>{new Date(order.date_created).toLocaleString()}</span>,
      address: order.address,
      from: (
        <span>
          {/*@ts-ignore*/}
          <span className="text-black">{Number(order.fiat_amount).toFixed(2)}</span> {order.fiat_currency}
        </span>
      ),
      to: (
        <span className="text-black">
          {Number(order.crypto_amount).toFixed(5)} <span className="text-[#777e8a]">{order.crypto_currency}</span>
        </span>
      ),
      status: <span className={statusColors(order.status)}>{order.status}</span>,
    }))
  }, [orders, type])

  return (
    <div className="table-orders mb-6">
      <div className="table-orders_header">
        <div className="table-orders_title">
          <span>
            <FormattedMessage id={`type-${type.toLowerCase()}`} />
          </span>
        </div>
      </div>
      <Table className="mb-7 text-cl14 text-black" data={tableData} heads={TABLE_HEADS} classNames={{ row: "child:py-[22px]" }} />
      {isNotFound && <div className="table-orders_item flex justify-center text-[16px] !min-w-0">No orders found.</div>}
    </div>
  )
}
